/* Travelhawk Theme — theme.js
 * Handles: Cart (Ajax), Gallery, Variant picker, Sticky CTA,
 *          Mega menu, Search overlay, Accordions, Announcement
 */

(function () {
  'use strict';

  /* ─── Helpers ─────────────────────────────────────── */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const fmt = (cents) => '€' + (cents / 100).toFixed(2).replace('.', ',').replace(',00', '');

  /* ─── Cart State ───────────────────────────────────── */
  const shipBar = document.getElementById('cd-ship-bar');
  const SHIP_THRESHOLD = shipBar ? parseInt(shipBar.dataset.threshold, 10) || 5000 : 5000;

  let cart = { items: [], item_count: 0, total_price: 0 };
  const productCache = new Map();

  async function fetchCart() {
    const res = await fetch('/cart.js');
    cart = await res.json();
    renderCart();
    updateCartBadge();
    return cart;
  }

  /* Shopify neemt per verzoek hoogstens 40 stuks aan. Grotere aantallen
     zetten we daarom in stappen van 40 in de winkelwagen. */
  const MAX_PER_VERZOEK = 40;

  async function voegToeInStappen(variantId, aantal) {
    let gedaan = 0;
    while (gedaan < aantal) {
      const stap = Math.min(MAX_PER_VERZOEK, aantal - gedaan);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: stap }),
      });
      if (!res.ok) break;
      gedaan += stap;
    }
    return gedaan;
  }

  async function addToCart(variantId, qty = 1) {
    const aantal = Math.max(1, parseInt(qty, 10) || 1);
    const gedaan = await voegToeInStappen(variantId, aantal);
    if (!gedaan) return;
    await fetchCart();
    openCart();
  }

  /* Beschikbaar maken voor secties (collectie- en bestsellerknoppen) */
  window.TH = Object.assign(window.TH || {}, {
    addToCart: function (id, qty) { return addToCart(id, qty); },
    fetchCart: function () { return fetchCart(); },
  });

  async function updateCartItem(key, qty) {
    const doel = Math.max(0, parseInt(qty, 10) || 0);
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.min(MAX_PER_VERZOEK, doel) }),
    });
    if (!res.ok) return;
    cart = await res.json();
    if (doel > MAX_PER_VERZOEK) {
      const variantId = String(key).split(':')[0];
      await voegToeInStappen(variantId, doel - MAX_PER_VERZOEK);
      cart = await (await fetch('/cart.js')).json();
    }
    renderCart();
    updateCartBadge();
  }

  function updateCartBadge() {
    const badge = $('#cart-count');
    if (!badge) return;
    if (cart.item_count > 0) {
      badge.textContent = cart.item_count;
      badge.style.display = 'flex';
    } else {
      badge.style.display = 'none';
    }
    // Update cart drawer count
    const cdCount = $('#cd-count');
    if (cdCount) cdCount.textContent = cart.item_count;
  }

  function renderCart() {
    const emptyState = $('#cd-empty-state');
    const itemsWrap  = $('#cd-items-wrap');
    const foot       = $('#cd-foot');
    const lineItems  = $('#cd-line-items');

    if (!lineItems) return;

    if (cart.item_count === 0) {
      if (emptyState) emptyState.style.display = '';
      if (itemsWrap)  itemsWrap.style.display = 'none';
      if (foot)       foot.style.display = 'none';
      return;
    }

    if (emptyState) emptyState.style.display = 'none';
    if (itemsWrap)  itemsWrap.style.display = '';
    if (foot)       foot.style.display = '';

    // Shipping bar
    const remaining = Math.max(0, SHIP_THRESHOLD - cart.total_price);
    const progress  = Math.min(100, (cart.total_price / SHIP_THRESHOLD) * 100);
    const shipMsg   = $('#cd-ship-msg');
    const shipFill  = $('#cd-ship-fill');
    const shipFlag  = $('#cd-ship-flag');
    const i18n = window.TH_i18n || {};
    if (shipMsg) shipMsg.innerHTML = remaining === 0
      ? '<span>' + (i18n.ship_reached || 'Gefeliciteerd! Je hebt gratis verzending.') + '</span>'
      : '<span>' + (i18n.ship_remain_1 || 'Nog') + ' <b>' + fmt(remaining) + '</b> ' + (i18n.ship_remain_2 || 'tot je gratis verzending ontvangt.') + '</span>';
    if (shipFill) shipFill.style.width = progress + '%';
    if (shipFlag) {
      shipFlag.style.left = 'calc(' + progress + '% - 18px)';
      shipFlag.classList.toggle('reached', remaining === 0);
    }

    // Line items
    lineItems.innerHTML = cart.items.map(item => `
      <div class="cd-line-item" data-key="${item.key}">
        <div class="cd-li-media">
          ${item.image
            ? `<img src="${item.image}" alt="${item.title}" style="width:100%;height:100%;object-fit:contain;padding:6px;box-sizing:border-box;">`
            : '<div style="width:60px;height:60px;background:var(--paper);border-radius:8px;border:1px solid var(--line)"></div>'}
        </div>
        <div class="cd-li-info">
          <div class="cd-li-row1">
            <div style="min-width:0">
              <div class="cd-li-name">${item.product_title}</div>
              ${item.variant_title && item.variant_title !== 'Default Title' ? `<div style="font-size:12px;color:var(--muted)">${item.variant_title}</div>` : ''}
            </div>
            <div class="cd-li-price">${fmt(item.final_line_price)}</div>
          </div>
          <div class="cd-li-compare" data-handle="${item.handle}" data-variant="${item.variant_id}" data-qty="${item.quantity}" data-final="${item.final_line_price}" style="margin-top:2px"></div>
          <div class="cd-li-controls">
            <div class="cd-qty-stepper">
              <button aria-label="Minder" data-key="${item.key}" data-qty="${item.quantity - 1}" class="cd-qty-btn">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/></svg>
              </button>
              <input class="cd-qty-v" type="number" inputmode="numeric" min="1" max="999"
                     value="${item.quantity}" data-key="${item.key}" aria-label="Aantal">

              <button aria-label="Meer" data-key="${item.key}" data-qty="${item.quantity + 1}" class="cd-qty-btn">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg>
              </button>
            </div>
            <button class="cd-li-remove" data-key="${item.key}" data-qty="0">${(window.TH_i18n && window.TH_i18n.remove) || 'Verwijderen'}</button>
          </div>
        </div>
      </div>
    `).join('');

    // Discount row — berekend na product-fetches (compare_at_price zit niet in cart.js)
    const discountRow = $('#cd-row-discount');
    const discountEl  = $('#cd-discount');
    if (discountRow) discountRow.style.display = 'none';

    // Shipping row
    const shipRowEl = $('#cd-shipping');
    if (shipRowEl) {
      const shipRemain = Math.max(0, SHIP_THRESHOLD - cart.total_price);
      if (shipRemain === 0) {
        shipRowEl.textContent = (window.TH_i18n && window.TH_i18n.free) || 'Gratis';
        shipRowEl.style.color = '#2c6b1f';
        shipRowEl.style.fontWeight = '600';
      } else {
        shipRowEl.textContent = ((window.TH_i18n && window.TH_i18n.free_over) || 'Gratis boven') + ' €' + (SHIP_THRESHOLD / 100).toFixed(0) + ',-';
        shipRowEl.style.color = 'var(--muted)';
        shipRowEl.style.fontWeight = '';
      }
    }

    // Subtotal
    const sub = $('#cd-subtotal');
    if (sub) sub.textContent = fmt(cart.total_price) + ' EUR';

    // Bind qty buttons
    $$('.cd-qty-btn, .cd-li-remove', lineItems).forEach(btn => {
      btn.addEventListener('click', () => {
        updateCartItem(btn.dataset.key, parseInt(btn.dataset.qty, 10));
      });
    });

    /* Aantal zelf intypen. Shopify begrenst zelf op de beschikbare voorraad,
       dus we sturen door wat de klant invult en tonen daarna wat het werd. */
    $$('.cd-qty-v', lineItems).forEach(veld => {
      const verwerk = () => {
        const gewenst = parseInt(veld.value, 10);
        if (!Number.isFinite(gewenst) || gewenst < 1) {
          veld.value = veld.defaultValue;
          return;
        }
        if (gewenst === parseInt(veld.defaultValue, 10)) return;
        updateCartItem(veld.dataset.key, gewenst);
      };
      veld.addEventListener('change', verwerk);
      veld.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') { e.preventDefault(); veld.blur(); }
      });
      veld.addEventListener('focus', () => veld.select());
    });

    // Korting badges ophalen per product + totale kortingsrij bijwerken
    (async function() {
      let totalSavings = 0;
      const compareEls = $$('.cd-li-compare', lineItems);
      await Promise.all(compareEls.map(async (el) => {
        const handle = el.dataset.handle;
        if (!handle) return;
        try {
          let product = productCache.get(handle);
          if (!product) {
            const res = await fetch('/products/' + handle + '.js');
            product = await res.json();
            productCache.set(handle, product);
          }
          const variant = product.variants.find(v => String(v.id) === el.dataset.variant);
          if (!variant || !variant.compare_at_price) return;
          const compareAt = parseInt(variant.compare_at_price, 10);
          const qty = parseInt(el.dataset.qty, 10);
          const finalLine = parseInt(el.dataset.final, 10);
          const compareLine = compareAt * qty;
          if (compareLine <= finalLine) return;
          totalSavings += compareLine - finalLine;
          /* Prijs als afgeprijsd markeren (stijl 2 kleurt hem dan rood) */
          const lineItem = el.closest('.cd-line-item');
          const priceEl = lineItem && lineItem.querySelector('.cd-li-price');
          if (priceEl) priceEl.classList.add('is-sale');
          const saveStyle = (window.TH_i18n && window.TH_i18n.save_red)
            ? 'color:#fff;background:var(--sale,#e8261a)'
            : 'color:#2c4419;background:#EEF2E7';
          el.innerHTML = `
            <div style="display:flex;align-items:center;gap:7px">
              <span style="font-size:12px;color:var(--muted);text-decoration:line-through">${fmt(compareLine)}</span>
              <span style="font-size:11px;font-weight:600;${saveStyle};padding:2px 8px;border-radius:99px">${(window.TH_i18n && window.TH_i18n.save) || 'Bespaar'} ${fmt(compareLine - finalLine)}</span>
            </div>`;
        } catch (e) { /* stil falen */ }
      }));
      const dRow = $('#cd-row-discount');
      const dEl  = $('#cd-discount');
      if (dRow) dRow.style.display = totalSavings > 0 ? '' : 'none';
      if (dEl && totalSavings > 0) dEl.textContent = '- ' + fmt(totalSavings);
    })();
  }

  /* ─── Cart Drawer open/close ───────────────────────── */
  function openCart() {
    const backdrop = $('#cd-backdrop');
    if (backdrop) backdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
    const stickyMob  = document.getElementById('sticky-mob');
    const stickyDesk = document.getElementById('sticky-desk');
    if (stickyMob)  stickyMob.style.display  = 'none';
    if (stickyDesk) stickyDesk.style.display = 'none';
  }

  function closeCart() {
    const backdrop = $('#cd-backdrop');
    if (backdrop) backdrop.classList.remove('open');
    document.body.style.overflow = '';
    const stickyMob  = document.getElementById('sticky-mob');
    const stickyDesk = document.getElementById('sticky-desk');
    if (stickyMob)  stickyMob.style.display  = '';
    if (stickyDesk) stickyDesk.style.display = '';
  }

  /* ─── Taalwisselaar dropdown ───────────────────────── */
  function initLangSwitcher() {
    const switchers = $$('[data-lang-switcher]');
    if (!switchers.length) return;

    // Verzamel alle taal-codes (voor het strippen van de prefix uit het pad)
    const codes = [];
    $$('input[name="locale_code"]').forEach(i => { if (i.value) codes.push(i.value.toLowerCase()); });

    // Geef altijd het SCHONE pad terug (zonder taal-prefix), zodat Shopify
    // de nieuwe taal er zelf voor zet en er geen /de/en/... stapeling ontstaat
    function cleanPath() {
      let p = window.location.pathname || '/';
      const parts = p.split('/');
      const seg = (parts[1] || '').toLowerCase();
      if (codes.indexOf(seg) !== -1) {
        p = '/' + parts.slice(2).join('/');
      }
      return p === '' ? '/' : p;
    }

    switchers.forEach(sw => {
      const toggle = $('.th-lang-toggle', sw);
      if (toggle) {
        toggle.addEventListener('click', (e) => {
          e.stopPropagation();
          const open = sw.getAttribute('aria-open') === 'true';
          switchers.forEach(o => { if (o !== sw) o.setAttribute('aria-open', 'false'); });
          sw.setAttribute('aria-open', open ? 'false' : 'true');
          toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      }
      // Zet het schone pad in return_to net vóór verzenden
      $$('form', sw).forEach(f => {
        f.addEventListener('submit', () => {
          const rt = f.querySelector('input[name="return_to"]');
          if (rt) rt.value = cleanPath();
        });
      });
    });

    // Klik buiten = sluiten
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-lang-switcher]')) {
        switchers.forEach(sw => { sw.setAttribute('aria-open', 'false'); const t = $('.th-lang-toggle', sw); if (t) t.setAttribute('aria-expanded', 'false'); });
      }
    });
  }

  /* ─── Staffelkorting selector ──────────────────────── */
  window.THqty = 1;
  function initQtyBreaks() {
    const groups = $$('.qty-breaks');
    if (!groups.length) return;
    function selectPill(pill) {
      const group = pill.closest('.qty-breaks');
      $$('.qb-pill', group).forEach(p => { p.classList.remove('active'); p.setAttribute('aria-pressed', 'false'); });
      pill.classList.add('active');
      pill.setAttribute('aria-pressed', 'true');
      window.THqty = parseInt(pill.dataset.qty, 10) || 1;
      // Alle selectors synchroon zetten (desktop + mobiel)
      $$('.qty-breaks').forEach(g => {
        $$('.qb-pill', g).forEach(p => {
          const on = p.dataset.qty === pill.dataset.qty;
          p.classList.toggle('active', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
      // Knopprijs bijwerken naar totaal
      const total = pill.dataset.total;
      if (total) {
        const label = '€' + (parseInt(total, 10) / 100).toFixed(2).replace('.', ',').replace(',00', '');
        const bp = $('#btn-price'); if (bp) bp.textContent = label;
        const mbp = $('#mob-btn-price'); if (mbp) mbp.textContent = label;
      }
    }
    groups.forEach(group => {
      group.addEventListener('click', (e) => {
        const pill = e.target.closest('.qb-pill');
        if (pill) selectPill(pill);
      });
    });
  }

  /* ─── Add to cart form ─────────────────────────────── */
  function initAddToCart() {
    const btn = $('#add-to-cart-btn');
    if (!btn) return;
    btn.addEventListener('click', async () => {
      const variantId = $('#variant-id').value;
      if (!variantId || btn.disabled) return;
      /* Bewaar de knop zoals hij was, inclusief het prijs-element. updateBtnLabel
         werkt alleen bij het eerste ontwerp; zonder deze terugval bleef de knop
         op "Toevoegen..." staan. */
      const origineel = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = (window.TH_i18n && window.TH_i18n.adding) || 'Toevoegen...';
      try {
        await addToCart(variantId, window.THqty || 1);
      } finally {
        btn.disabled = false;
        btn.innerHTML = origineel;
        updateBtnLabel();
      }
    });

    // Mobiele ATC knop
    const mobBtn = $('#mob-atc-btn');
    if (mobBtn) {
      mobBtn.addEventListener('click', async () => {
        const variantId = $('#mob-variant-id')?.value || $('#variant-id')?.value;
        if (!variantId || mobBtn.disabled) return;
        mobBtn.disabled = true;
        await addToCart(variantId, window.THqty || 1);
        mobBtn.disabled = false;
      });
    }
  }

  /* ─── Variant / Bundle picker ──────────────────────── */
  function initVariantPicker() {
    const picker = $('#bundle-picker');
    if (!picker) return;

    picker.addEventListener('click', (e) => {
      const bundle = e.target.closest('[data-variant-id]');
      if (!bundle) return;

      $$('[data-variant-id]', picker).forEach(b => {
        b.classList.remove('active');
        b.setAttribute('aria-pressed', 'false');
      });
      bundle.classList.add('active');
      bundle.setAttribute('aria-pressed', 'true');

      const variantId = bundle.dataset.variantId;
      const price     = parseInt(bundle.dataset.price, 10);
      const compare   = parseInt(bundle.dataset.compare, 10);

      // Update hidden input
      const input = $('#variant-id');
      if (input) input.value = variantId;

      // Update price display
      const pSale = $('#price-sale');
      const pReg  = $('#price-regular');
      const pSave = $('#price-save');
      if (pSale) pSale.textContent = fmt(price);
      if (pReg)  pReg.textContent  = compare > price ? fmt(compare) : '';
      if (pSave) pSave.textContent = compare > price ? ((window.TH_i18n && window.TH_i18n.save) || 'Bespaar') + ' ' + fmt(compare - price) : '';

      updateBtnLabel(price);
      updateStickyMob(bundle);
      updateStickyDesk(bundle);
    });

    // keyboard
    picker.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        const bundle = e.target.closest('[data-variant-id]');
        if (bundle) { e.preventDefault(); bundle.click(); }
      }
    });
  }

  function updateBtnLabel(price) {
    const btn = $('#add-to-cart-btn');
    if (!btn) return;
    const active = $('#bundle-picker .bundle.active');
    const p = price || (active ? parseInt(active.dataset.price, 10) : null);
    if (p) btn.innerHTML = 'Toevoegen aan winkelwagen &middot; <span>' + fmt(p) + '</span>';
  }

  /* ─── Variant optie-kiezer (kleur / maat) ──────────── */
  function initOptionPicker() {
    $$('[data-option-picker]').forEach(function (picker) {
      const jsonEl = picker.querySelector('[data-variants-json]');
      if (!jsonEl) return;
      let variants;
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      const inputId = picker.getAttribute('data-variant-input');
      const isMob = picker.getAttribute('data-context') === 'mob';

      function currentSelection() {
        const sel = {};
        $$('.th-opt-btn.active', picker).forEach(function (b) { sel[b.dataset.optPosition] = b.dataset.optValue; });
        return sel;
      }
      function findVariant(sel) {
        for (let i = 0; i < variants.length; i++) {
          const v = variants[i]; let match = true;
          for (const pos in sel) { if (v.options[parseInt(pos, 10) - 1] !== sel[pos]) { match = false; break; } }
          if (match) return v;
        }
        return null;
      }
      function apply(v) {
        if (!v) return;
        const input = document.getElementById(inputId);
        if (input) input.value = v.id;
        const saleEl = document.getElementById(isMob ? 'mob-price-sale' : 'price-sale');
        const regEl  = document.getElementById(isMob ? 'mob-price-regular' : 'price-regular');
        const saveEl = document.getElementById(isMob ? 'mob-price-save' : 'price-save');
        const hasCompare = v.compare && v.compare > v.price;
        if (saleEl) saleEl.textContent = fmt(v.price);
        const priceBox = document.getElementById('pv2-price-box');
        if (priceBox) priceBox.classList.toggle('is-sale', !!hasCompare);
        if (regEl)  { regEl.textContent = hasCompare ? fmt(v.compare) : ''; regEl.style.display = hasCompare ? '' : 'none'; }
        if (saveEl) {
          if (hasCompare) { saveEl.style.display = ''; saveEl.textContent = ((window.TH_i18n && window.TH_i18n.save) || 'Bespaar') + ' ' + fmt(v.compare - v.price); }
          else saveEl.style.display = 'none';
        }
        const btn = document.getElementById(isMob ? 'mob-atc-btn' : 'add-to-cart-btn');
        if (btn) {
          if (v.available) {
            btn.disabled = false; btn.style.opacity = '';
            const lbl = (window.TH_i18n && window.TH_i18n.add_to_cart) || 'Toevoegen aan winkelwagen';
            btn.innerHTML = lbl + ' &middot; <span>' + fmt(v.price) + '</span>';
          } else {
            btn.disabled = true; btn.style.opacity = '0.6';
            btn.textContent = (window.TH_i18n && window.TH_i18n.sold_out) || 'Uitverkocht';
          }
        }

        /* Toon de foto die bij deze variant hoort */
        if (v.image_id) {
          if (isMob) {
            const mobImg = document.getElementById('mob-main-img');
            if (mobImg && v.image) mobImg.src = v.image;
            const mobThumbs = $$('#mob-thumbs .mob-thumb');
            mobThumbs.forEach(function (t) {
              const on = String(t.dataset.imageId) === String(v.image_id);
              t.style.borderColor = on ? '#3C6E2E' : '#e5e3dc';
              if (on) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
            });
            const mobCounter = document.getElementById('mob-counter');
            const hit = mobThumbs.findIndex(t => String(t.dataset.imageId) === String(v.image_id));
            if (mobCounter && hit > -1) mobCounter.textContent = (hit + 1) + ' / ' + mobThumbs.length;
          } else if (typeof window.THshowImage === 'function') {
            window.THshowImage(v.image_id);
          }
        }
      }

      picker.addEventListener('click', function (e) {
        const btn = e.target.closest('.th-opt-btn');
        if (!btn) return;
        const pos = btn.dataset.optPosition;
        $$('.th-opt-btn[data-opt-position="' + pos + '"]', picker).forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        const selLabel = picker.querySelector('[data-opt-sel="' + pos + '"]');
        if (selLabel) selLabel.textContent = btn.dataset.optValue;
        apply(findVariant(currentSelection()));
      });

      /* De galerij begint bij de eerste foto. Meestal is dat prima en laten we
         hem met rust. Alleen als die eerste foto bij een uitverkochte variant
         hoort (dan zag je bijv. de groene tas terwijl zwart geselecteerd stond),
         of als er een variant in de URL staat, springen we naar de juiste foto. */
      (function toonStartfoto() {
        var v = findVariant(currentSelection());
        if (!v || !v.image_id) return;

        var uitUrl = /[?&]variant=(\d+)/.exec(window.location.search);
        if (!uitUrl) {
          var eerste = document.querySelector('#gallery-main .slide, #mob-thumbs .mob-thumb');
          var eersteId = eerste && eerste.dataset ? eerste.dataset.imageId : null;
          if (!eersteId) return;
          if (String(eersteId) === String(v.image_id)) return; // staat al goed
          var hoortBijUitverkocht = variants.some(function (x) {
            return String(x.image_id) === String(eersteId) && !x.available;
          });
          if (!hoortBijUitverkocht) return; // eerste foto is gewoon bruikbaar
        }
        if (isMob) {
          var mobImg = document.getElementById('mob-main-img');
          if (mobImg && v.image) mobImg.src = v.image;
        } else if (typeof window.THshowImage === 'function') {
          window.THshowImage(v.image_id);
        } else {
          /* galerij is nog niet klaar: even later opnieuw proberen */
          setTimeout(function () {
            if (typeof window.THshowImage === 'function') window.THshowImage(v.image_id);
          }, 0);
        }
      })();
    });
  }

  /* ─── Sticky CTA ───────────────────────────────────── */
  function initStickyCta() {
    const doAdd = () => {
      const id = document.getElementById('variant-id') && document.getElementById('variant-id').value
               || document.getElementById('mob-variant-id') && document.getElementById('mob-variant-id').value;
      if (id) addToCart(id, window.THqty || 1);
    };

    /* gedeelde scroll-logica: toon sticky wanneer knop boven viewport verdwijnt.
       Watch-knop kan verborgen zijn (rect 0) op het andere breekpunt — dan doet
       CSS (media queries) de zichtbaarheid, dus dat is onschadelijk. */
    function scrollShow(el, watchBtn) {
      function update() {
        var rect = watchBtn.getBoundingClientRect();
        // knop volledig verborgen (display:none) → niet forceren
        var hidden = rect.width === 0 && rect.height === 0;
        /* Verbergen zodra de footer in beeld komt, zodat hij niets afdekt */
        var foot = document.querySelector('footer.dth-foot, footer.th-f2');
        var atFooter = foot ? foot.getBoundingClientRect().top < window.innerHeight - 20 : false;
        el.classList.toggle('on', !hidden && rect.bottom < 80 && !atFooter);
      }
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    }

    /* ── MOBIEL ── (altijd opzetten; CSS toont alleen ≤768px) */
    (function () {
      const mob    = document.getElementById('sticky-mob');
      const buyBtn = document.getElementById('mob-atc-btn') || $('[data-buy-cta]');
      if (!mob || !buyBtn) return;

      updateStickyMob(null);
      scrollShow(mob, buyBtn);

      /* Verberg sticky wanneer openingstijden in beeld komen */
      const hoursEl = document.querySelector('.dth-foot-hours');
      if (hoursEl) {
        window.addEventListener('scroll', function () {
          var rect = hoursEl.getBoundingClientRect();
          if (rect.top < window.innerHeight) mob.classList.remove('on');
        }, { passive: true });
      }

      const btn = document.getElementById('smob-btn');
      if (btn) btn.addEventListener('click', doAdd);
    })();

    /* ── DESKTOP ── (altijd opzetten; CSS toont alleen >768px) */
    (function () {
      const desk   = document.getElementById('sticky-desk');
      const buyBtn = document.getElementById('add-to-cart-btn') || $('[data-buy-cta]');
      if (!desk || !buyBtn) return;

      const titleEl = document.getElementById('sdesk-title');
      if (titleEl) {
        const h = document.querySelector('h1');
        if (h) titleEl.textContent = h.textContent.trim();
      }

      const thumb = document.getElementById('sdesk-thumb');
      if (thumb) {
        const firstSlide = $('.gallery-main .slide');
        const firstImg = firstSlide ? firstSlide.querySelector('img') : $('.gallery-main img');
        if (firstImg) thumb.innerHTML = `<img src="${firstImg.src}" alt="">`;
      }

      const activeBundle = $('#bundle-picker .bundle.active');
      updateStickyDesk(activeBundle || null);
      scrollShow(desk, buyBtn);

      /* Aantal-teller in de brede balk (stijl 2) */
      let deskQty = 1;
      const qtyWrap = document.getElementById('sdesk-qty');
      const qtyVal  = document.getElementById('sdesk-qty-val');

      /* Prijs in de balk en in de knop meerekenen met het aantal */
      window.THdeskRenderQty = function () {
        const unit = window.THdeskUnit || 0;
        if (!unit) return;
        const compareUnit = window.THdeskCompareUnit || 0;
        const total = unit * deskQty;

        const nowEl = document.querySelector('#sdesk-prices .now');
        if (nowEl) nowEl.textContent = fmt(total);

        const btnPrice = document.getElementById('sdesk-btn-price');
        if (btnPrice) btnPrice.textContent = fmt(total);

        /* Streepprijs en 'Bespaar' meerekenen met het aantal */
        const wasEl = document.querySelector('#sdesk-prices .was');
        if (wasEl && compareUnit > unit) wasEl.textContent = fmt(compareUnit * deskQty);

        const badge = document.getElementById('sdesk-badge');
        if (badge && badge.textContent) {
          badge.textContent = compareUnit > unit
            ? ((window.TH_i18n && window.TH_i18n.save) || 'Bespaar') + ' ' + fmt((compareUnit - unit) * deskQty)
            : '';
        }
      };

      if (qtyWrap && qtyVal) {
        qtyWrap.addEventListener('click', function (e) {
          const stepBtn = e.target.closest('[data-qty-step]');
          if (!stepBtn) return;
          deskQty = Math.max(1, deskQty + parseInt(stepBtn.dataset.qtyStep, 10));
          qtyVal.textContent = deskQty;
          window.THdeskRenderQty();
        });
      }

      const btn = document.getElementById('sdesk-btn');
      if (btn) btn.addEventListener('click', function () {
        const id = document.getElementById('variant-id') && document.getElementById('variant-id').value
                 || document.getElementById('mob-variant-id') && document.getElementById('mob-variant-id').value;
        if (id) addToCart(id, deskQty > 1 ? deskQty : (window.THqty || 1));
      });
    })();
  }

  function updateStickyMob(bundle) {
    const pricesEl = document.getElementById('smob-prices');
    if (!pricesEl) return;

    function render(now, was) {
      pricesEl.innerHTML = (was ? `<span class="was">${was}</span>` : '') + `<span class="now">${now}</span>`;
    }

    if (!bundle) {
      const s = $('#price-sale'), r = $('#price-regular');
      if (s) render(s.textContent.trim(), r ? r.textContent.trim() : '');
      return;
    }
    const p = parseInt(bundle.dataset.price, 10), c = parseInt(bundle.dataset.compare, 10);
    render(fmt(p), c > p ? fmt(c) : '');
  }

  function updateStickyDesk(bundle) {
    const pricesEl = document.getElementById('sdesk-prices');
    const badgeEl  = document.getElementById('sdesk-badge');
    const varEl    = document.getElementById('sdesk-variant');
    if (!pricesEl) return;

    const btnPriceEl = document.getElementById('sdesk-btn-price');

    /* Prijs in centen onthouden zodat de aantal-teller kan doorrekenen */
    function toCents(txt) {
      if (!txt) return 0;
      const m = String(txt).replace(/\s/g, '').match(/(\d+)(?:[.,](\d{1,2}))?/);
      if (!m) return 0;
      return parseInt(m[1], 10) * 100 + parseInt((m[2] || '0').padEnd(2, '0'), 10);
    }

    function render(now, was, save, variant) {
      pricesEl.innerHTML = (was ? `<span class="was">${was}</span>` : '') + `<span class="now${was ? ' is-sale' : ''}">${now}</span>`;
      if (badgeEl) badgeEl.textContent = save || '';
      if (varEl)   varEl.textContent   = variant || '';
      if (btnPriceEl) btnPriceEl.textContent = now || '';
      window.THdeskUnit = bundle ? parseInt(bundle.dataset.price, 10) : toCents(now);
      window.THdeskCompareUnit = bundle ? (parseInt(bundle.dataset.compare, 10) || 0) : toCents(was);
      if (typeof window.THdeskRenderQty === 'function') window.THdeskRenderQty();
    }

    if (!bundle) {
      const s = $('#price-sale'), r = $('#price-regular'), sv = $('#price-save');
      if (s) render(s.textContent.trim(), r ? r.textContent.trim() : '', sv ? sv.textContent.trim() : '', '');
      return;
    }
    const p = parseInt(bundle.dataset.price, 10), c = parseInt(bundle.dataset.compare, 10);
    const label = bundle.querySelector('.bundle-label');
    render(fmt(p), c > p ? fmt(c) : '', c > p ? ((window.TH_i18n && window.TH_i18n.save) || 'Bespaar') + ' ' + fmt(c - p) : '', label ? label.textContent.trim() : '');
  }

  /* ─── Product Gallery ──────────────────────────────── */
  function initGallery() {
    const main   = $('#gallery-main');
    const thumbs = $('#gallery-thumbs');
    const prev   = $('#gallery-prev');
    const next   = $('#gallery-next');
    const counter= $('#gallery-counter');
    if (!main) return;

    const slides = $$('.slide', main);
    if (slides.length === 0) return;
    let idx = 0;

    /* Op mobiel schuift de galerij echt mee met je vinger (scroll-snap).
       Op desktop blijft het een overvloeier tussen de foto's. */
    const mobiel = window.matchMedia('(max-width: 749px)');
    const isVeeg = () => mobiel.matches;

    function markeer(n) {
      slides[idx]?.classList.remove('active');
      if (thumbs) $$('.thumb', thumbs)[idx]?.classList.remove('active');
      idx = (n + slides.length) % slides.length;
      slides[idx]?.classList.add('active');
      if (thumbs) $$('.thumb', thumbs)[idx]?.classList.add('active');
      if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
    }

    /* Direct verspringen, ook als de pagina een vloeiende scroll afdwingt */
    function springNaar(pos) {
      const oud = main.style.scrollBehavior;
      main.style.scrollBehavior = 'auto';
      main.scrollLeft = pos;
      main.style.scrollBehavior = oud;
    }

    function goTo(n, direct) {
      const doel = (n + slides.length) % slides.length;
      if (isVeeg()) {
        markeer(doel);
        // Elke foto is precies zo breed als de galerij, dus de positie is een veelvoud daarvan
        const doelPos = main.clientWidth * doel;
        if (direct) {
          springNaar(doelPos);
        } else {
          main.scrollTo({ left: doelPos, behavior: 'smooth' });
          // Loopt de animatie niet (bijv. omdat de browser hem overslaat),
          // dan zetten we de galerij alsnog op de juiste foto.
          setTimeout(function () {
            if (Math.abs(main.scrollLeft - doelPos) > 4) springNaar(doelPos);
          }, 500);
        }
        return;
      }
      markeer(doel);
    }

    /* Tijdens het vegen bijhouden welke foto in beeld staat */
    if (slides.length > 1) {
      let bezig;
      main.addEventListener('scroll', () => {
        if (!isVeeg()) return;
        clearTimeout(bezig);
        bezig = setTimeout(() => {
          const breedte = main.clientWidth || 1;
          const n = Math.round(main.scrollLeft / breedte);
          if (n !== idx && slides[n]) markeer(n);
        }, 60);
      }, { passive: true });
    }

    /* Laat andere onderdelen (bijv. de kleurkiezer) naar een foto springen */
    window.THshowImage = function (imageId) {
      if (!imageId) return;
      const target = slides.findIndex(s => String(s.dataset.imageId) === String(imageId));
      if (target > -1 && target !== idx) goTo(target);
    };

    if (prev) prev.addEventListener('click', () => goTo(idx - 1));
    if (next) next.addEventListener('click', () => goTo(idx + 1));

    if (thumbs) {
      $$('.thumb', thumbs).forEach((btn, i) => {
        btn.addEventListener('click', () => goTo(i));
      });
    }

    // Vegen op schermen waar de galerij niet zelf schuift
    let startX = 0;
    main.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', e => {
      if (isVeeg()) return; // daar doet scroll-snap het werk al
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) goTo(dx < 0 ? idx + 1 : idx - 1);
    });

    // Thumbnail row slider (desktop, >6 images)
    const thumbPrev = $('#thumbs-prev');
    const thumbNext = $('#thumbs-next');
    if (thumbs && thumbPrev && thumbNext) {
      const THUMB_STEP = 3; // scroll 3 thumbs at a time
      function updateThumbNav() {
        const allThumbs = $$('.thumb', thumbs);
        const visible = Math.round(thumbs.offsetWidth / (allThumbs[0]?.offsetWidth + 8 || 90));
        const maxOffset = allThumbs.length - visible;
        const currentOffset = Math.round(thumbs.scrollLeft / ((allThumbs[0]?.offsetWidth || 82) + 8));
        thumbPrev.disabled = currentOffset <= 0;
        thumbNext.disabled = currentOffset >= maxOffset;
      }
      thumbPrev.addEventListener('click', () => {
        const w = ($$('.thumb', thumbs)[0]?.offsetWidth || 82) + 8;
        thumbs.scrollBy({ left: -w * THUMB_STEP, behavior: 'smooth' });
        setTimeout(updateThumbNav, 320);
      });
      thumbNext.addEventListener('click', () => {
        const w = ($$('.thumb', thumbs)[0]?.offsetWidth || 82) + 8;
        thumbs.scrollBy({ left: w * THUMB_STEP, behavior: 'smooth' });
        setTimeout(updateThumbNav, 320);
      });
      thumbs.addEventListener('scroll', updateThumbNav, { passive: true });
      updateThumbNav();
    }
  }

  /* ─── Shipping info modal ──────────────────────────── */
  function initShipModal() {
    const btn     = $('#ship-info-btn');
    const backdrop= $('#ship-backdrop');
    const closeBtn= $('#ship-close');
    if (!backdrop) return;
    if (btn) btn.addEventListener('click', () => backdrop.classList.add('open'));
    closeBtn?.addEventListener('click', () => backdrop.classList.remove('open'));
    backdrop.addEventListener('click', e => { if (e.target === backdrop) backdrop.classList.remove('open'); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') backdrop.classList.remove('open'); });
  }

  /* ─── Mega menu ────────────────────────────────────── */
  function initMegaMenu() {
    $$('[data-mega]').forEach(item => {
      const mega = $('.mega', item);
      if (!mega) return;
      let t;
      item.addEventListener('mouseenter', () => { clearTimeout(t); mega.classList.add('open'); });
      item.addEventListener('mouseleave', () => { t = setTimeout(() => mega.classList.remove('open'), 120); });
    });
  }

  /* ─── Search overlay ───────────────────────────────── */
  function initSearch() {
    const overlay  = $('#search-overlay');
    const closeBtn = $('#search-close');
    const input    = $('#search-input');

    $$('#search-btn-desktop, #search-btn-mobile').forEach(btn => {
      btn.addEventListener('click', () => {
        overlay?.classList.add('on');
        setTimeout(() => input?.focus(), 50);
      });
    });
    closeBtn?.addEventListener('click', () => overlay?.classList.remove('on'));
    overlay?.addEventListener('click', e => { if (e.target === overlay) overlay.classList.remove('on'); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') overlay?.classList.remove('on'); });

    input?.addEventListener('keydown', e => {
      if (e.key === 'Enter' && input.value.trim()) {
        window.location.href = '/search?q=' + encodeURIComponent(input.value.trim());
      }
    });
  }

  /* ─── Cart drawer bindings — event delegation ─────── */
  function initCartDrawer() {
    // Gebruik event delegation op document zodat herlaad van sectie geen probleem is
    document.addEventListener('click', function(e) {
      // Open cart
      if (e.target.closest('#cart-btn')) { openCart(); return; }
      // Close via X knop
      if (e.target.closest('#cd-close')) { closeCart(); return; }
      // Close via "Doorgaan met winkelen"
      if (e.target.closest('#cd-keep-shopping')) { closeCart(); return; }
      // Close via backdrop
      if (e.target.id === 'cd-backdrop') { closeCart(); return; }
      // Upsell toevoegen
      var upsellBtn = e.target.closest('[data-upsell-id]');
      if (upsellBtn) {
        var id = upsellBtn.getAttribute('data-upsell-id');
        if (!id) return;
        upsellBtn.textContent = (window.TH_i18n && window.TH_i18n.added) || 'Toegevoegd';
        upsellBtn.style.background = 'var(--olive)';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        }).then(function() { fetchCart(); });
        return;
      }
      // Upsell slider knoppen
      if (e.target.closest('#cd-upsell-prev')) {
        var track = $('#cd-upsell-track');
        if (track) track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
        return;
      }
      if (e.target.closest('#cd-upsell-next')) {
        var track = $('#cd-upsell-track');
        if (track) track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
        return;
      }
    });

    // Escape sluit cart
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeCart(); });

    // Zoekbalk via delegation op keydown
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && e.target.id === 'cd-search-input' && e.target.value.trim()) {
        window.location.href = '/search?q=' + encodeURIComponent(e.target.value.trim());
      }
    });

    // Shopify customizer: herlaad cart bij section refresh
    document.addEventListener('shopify:section:load', function(e) {
      if (e.detail && e.detail.sectionId && e.detail.sectionId.indexOf('cart') > -1) {
        fetchCart();
      }
    });
  }

  /* ─── Mobile hamburger menu ───────────────────────── */
  function initMobileMenu() {
    const overlay  = $('#mm-overlay');
    const openBtn  = $('#mobile-menu-btn');
    const closeBtn = $('#mm-close');
    if (!overlay) return;

    function openMenu() {
      overlay.classList.add('mm-on');
      document.body.style.overflow = 'hidden';
      overlay.setAttribute('aria-hidden', 'false');
      // Sticky add-to-cart verbergen, anders valt hij over het menu heen
      const stickyMob  = document.getElementById('sticky-mob');
      const stickyDesk = document.getElementById('sticky-desk');
      if (stickyMob)  stickyMob.style.display  = 'none';
      if (stickyDesk) stickyDesk.style.display = 'none';
      closeBtn && closeBtn.focus();
    }

    const mmBody  = overlay.querySelector('.mm-body');
    const mmDrill = overlay.querySelector('[data-mm-drill]');

    function closeAllPanels() {
      if (mmDrill) mmDrill.querySelectorAll('.mm-panel.is-active').forEach(p => p.classList.remove('is-active'));
      if (mmBody)  mmBody.classList.remove('mm-drilled');
    }

    function closeMenu() {
      overlay.classList.remove('mm-on');
      document.body.style.overflow = '';
      overlay.setAttribute('aria-hidden', 'true');
      const stickyMob  = document.getElementById('sticky-mob');
      const stickyDesk = document.getElementById('sticky-desk');
      if (stickyMob)  stickyMob.style.display  = '';
      if (stickyDesk) stickyDesk.style.display = '';
      closeAllPanels();
    }

    openBtn && openBtn.addEventListener('click', openMenu);
    closeBtn && closeBtn.addEventListener('click', closeMenu);

    // Close on backdrop click (outside sheet)
    overlay.addEventListener('click', e => {
      if (e.target === overlay) closeMenu();
    });

    // Close on Escape
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && overlay.classList.contains('mm-on')) closeMenu();
    });

    // Drill-down: een niveau dieper
    $$('[data-mm-open]', overlay).forEach(btn => {
      btn.addEventListener('click', () => {
        const target = mmDrill && mmDrill.querySelector('[data-mm-panel="' + btn.getAttribute('data-mm-open') + '"]');
        if (!target) return;
        if (mmBody) { mmBody.scrollTop = 0; mmBody.classList.add('mm-drilled'); }
        target.classList.add('is-active');
        target.scrollTop = 0;
      });
    });

    // Drill-down: een niveau terug
    $$('[data-mm-back]', overlay).forEach(btn => {
      btn.addEventListener('click', () => {
        const panel = btn.closest('.mm-panel');
        if (panel) panel.classList.remove('is-active');
        if (mmDrill && !mmDrill.querySelector('.mm-panel.is-active') && mmBody) {
          mmBody.classList.remove('mm-drilled');
        }
      });
    });

    // Search: redirect to /search
    const searchInput = $('#mm-search-input');
    searchInput && searchInput.addEventListener('keydown', e => {
      if (e.key === 'Enter' && searchInput.value.trim()) {
        window.location.href = '/search?q=' + encodeURIComponent(searchInput.value.trim());
      }
    });
  }

  /* ─── Bootstrap ────────────────────────────────────── */

  /* ─── Trustpilot reviews carrousel ─────────────────── */
  function initTpReviews() {
    document.querySelectorAll('.tp-wrap').forEach(function (section) {
      var track   = section.querySelector('.tp-track');
      var wrap    = section.querySelector('.tp-track-wrap');
      var bar     = section.querySelector('.tp-progress-bar');
      var btnPrev = section.querySelector('.tp-arrow-prev');
      var btnNext = section.querySelector('.tp-arrow-next');
      if (!track || !wrap) return;

      var offset = 0;

      function cardWidth() {
        var card = track.querySelector('.tp-card');
        if (!card) return 0;
        var gap = parseFloat(getComputedStyle(track).gap) || 20;
        return card.offsetWidth + gap;
      }
      function maxOffset() { return Math.max(0, track.scrollWidth - wrap.offsetWidth); }
      function updateBar() {
        var max = maxOffset();
        var pct = max > 0 ? offset / max : 0;
        if (bar) bar.style.width = Math.round(20 + pct * 80) + '%';
      }
      function setOffset(val) {
        offset = Math.max(0, Math.min(maxOffset(), val));
        track.style.transform = 'translateX(-' + offset + 'px)';
        updateBar();
      }

      if (btnPrev) btnPrev.addEventListener('click', function () { setOffset(offset - cardWidth()); });
      if (btnNext) btnNext.addEventListener('click', function () { setOffset(offset + cardWidth()); });
      wrap.addEventListener('scroll', function () { offset = wrap.scrollLeft; updateBar(); });
      updateBar();
    });
  }
  /* ─── Sticky header height ─────────────────────────── */
  function initStickyHeader() {
    const announce = document.querySelector('.announce');
    if (!announce) return;
    const update = () => {
      document.documentElement.style.setProperty('--announce-h', announce.offsetHeight + 'px');
    };
    update();
    window.addEventListener('resize', update);
  }

  document.addEventListener('DOMContentLoaded', () => {
    // Elke init in eigen try/catch: een fout in de één mag de rest niet blokkeren
    var inits = [initTpReviews, initStickyHeader, fetchCart, initQtyBreaks, initLangSwitcher, initAddToCart,
                 initVariantPicker, initOptionPicker, initGallery, initStickyCta, initShipModal, initMegaMenu,
                 initSearch, initCartDrawer, initMobileMenu];
    inits.forEach(function(fn) {
      try { fn(); } catch (e) { if (window.console) console.warn('init fout:', e); }
    });
  });

  // Globaal beschikbaar voor andere secties (bijv. bestsellers ATC)
  window.TH = window.TH || {};
  window.TH.addToCart = addToCart;
  window.TH.openCart  = openCart;
  window.TH.fetchCart = fetchCart;

})();
